import { render } from "./CategoryForm.vue?vue&type=template&id=42bd4886&bindings={}"
import script from "./CategoryForm.vue?vue&type=script&lang=ts"
export * from "./CategoryForm.vue?vue&type=script&lang=ts"
script.render = render

export default script